import { render } from "./product-certificates.vue?vue&type=template&id=b5dd29a2"
import script from "./product-certificates.vue?vue&type=script&lang=js"
export * from "./product-certificates.vue?vue&type=script&lang=js"

import "./product-certificates.vue?vue&type=style&index=0&id=b5dd29a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__